<template>
    <div>

        <config-main-title v-if="!setup">
            Valores Particular
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3" v-if="!setup">
                <div class="col col-12 col-md-6">
                    <az-input
                        icon="fa fa-search"
                        placeholder="Pesquisar..."
                        v-model="search" />
                </div>
                <div class="col col-12 col-md-3">
                    <az-input
                        type="button-group"
                        :optionsList="[{id:'A', search:'Ativos'},{id:'T', search:'Todos'}]" 
                        v-model="viewModePlanos" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir_plano ()">
                        Incluir Plano
                    </button>
                </div>
            </div>

            <div v-else class="d-flex flex-column">
                <button type="button" class="btn btn-primary mb-3" @click="incluir_plano ()">
                    <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                    Incluir Modalidade Particular
                </button>
            </div>

        </div>

        <div v-if="( !lista_planos || !lista_planos.length || ( em_edicao && item && item.id_plano && !procedimentos ) )">
            <az-empty-state msg="Nenhum plano particular registrado." action="Incluir Plano" 
                :method="incluir_plano" />
		</div>

        <div v-else>
            <div class="progress mt-1 mb-3">
                <div class="indeterminate" v-if="$store.state.loading"></div>
                <div class="determinate" v-else></div>
            </div>
        </div>

        <div v-if="!em_edicao && lista_planos && lista_planos.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(plano, ip) in lista_planos" :key="ip">
                    <span>
                        <a href="#" @click.prevent="editar(plano)" class="h5 card-link mb-0 mr-3">
                            {{ plano.st_plano }}
                        </a>
                        <span class="badge badge-secondary ml-3">#{{ plano.id_plano }}</span>
                    </span>
                    <span class="d-flex">
                        <div v-if="plano.js_classes && plano.js_classes.length" class="mr-1">
                            <a href="#" @click.prevent="search == '&quot;' + tag + '&quot;' ? search = '' : search = '&quot;' + tag + '&quot;'"
                                    v-for="(tag, itx) in plano.js_classes" :key="itx">
                                <span class="badge badge-success mr-1">
                                    {{ tag }}
                                </span>
                            </a>
                        </div>
                        <div class="text-warning mr-3"
                            data-toggle="tooltip" data-placement="top" 
                            :title="plano.proc_count ? 'Nenhum procedimento ativo.' : 'Procedimentos ativos.'">
                            <i class="fas fa-exclamation-triangle" v-if="!plano.proc_count && plano.fl_ativo"></i>
                            <span class="badge badge-secondary" v-else>{{ plano.proc_count }}</span>
                        </div>
                        <div class="custom-control custom-switch" v-if="viewModePlanos == 'T'">
                            <input type="checkbox" class="custom-control-input" :id="'ativo-' + ip" 
                                v-model="plano.fl_ativo" 
                                @change="toggle_plano(plano)">
                            <label class="custom-control-label" :for="'ativo-' + ip"></label>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição de procedimento -->

        <div v-if="em_edicao && item">

            <az-break-title :title="item.st_plano" v-if="item && item.id_plano" />

            <div class="card" style="padding: 0px;" v-if="submenu == 'Procedimentos'">

                <div class="card-header bg-success text-white lead" v-if="item && !item.id_plano">
                    Novo 
                </div>

                <div class="card-body">
                    <div class="form-row">
                        <div class="col col-12 col-md-4">
                            <az-input 
                                label="Nome do Plano" 
                                required 
                                :validate="validate"
                                v-model="item.st_plano"/>
                        </div>
                        <div class="col col-12 col-md-2">
                            <az-input 
                                label="Prazo de Revisão (em dias)" 
                                placeholder="30"
                                v-model="item.in_prazo_revisao"/>
                        </div>
                        <template v-if="!setup">
                            <div class="col col-12 col-md-3">
                                <small>&nbsp;</small>
                                <az-input
                                    label="Campo de validade na recepção"
                                    type="checkbox-group"
                                    v-model="item.fl_validade_particular" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <small>&nbsp;</small>
                                <az-input
                                    label="Valor Editável na Recepção"
                                    type="checkbox-group"
                                    v-model="item.fl_valor_editavel" />
                            </div>
                        </template>
                    </div>

                    <div class="form-row" v-if="!setup">
                        <div class="col col-12 col-md-6">
                            <az-input
                                v-if="plano_com_fornecedor"
                                placeholder="Selecione a Empresa para Adiantamentos..."
                                icon="fas fa-building"
                                type="autocomplete" 
                                optionsMode="aql"
                                service="fornecedores.index"
                                :optionsParm="{ 
                                    ativas: true, 
                                }"
                                v-model="item.fornecedor" />
                        </div>
                        <div class="col col-12 col-md-4">
                            <az-input
                                label="Permitir agendamento on-line pelo portal do paciente"
                                type="checkbox-group"
                                v-model="item.fl_agenda_online" />
                        </div>
                        <div class="col col-12 col-md-2">
                            <az-input
                                :validate="validate"
                                placeholder="Id Externo"
                                v-model="item.st_id_externo" />
                        </div>
                    </div>

                    <div class="form-row mb-3" v-if="!setup">
                        <div class="col col-12">
                            <multiselect
                                v-model="item.js_classes"
                                :options="options_classes"
                                :multiple="true"
                                :taggable="true"
                                @tag="addTag"
                                placeholder="Selecione uma classificação..."
                                selectLabel="Pressione [ENTER] para selecionar"
                                deselectLabel="Pressione [ENTER] para remover"
                                tagPlaceholder="Pressione [ENTER] para incluir"
                                selectedLabel="Selecionado">
                                <template slot="noOptions">
                                    Nenhuma classificação criada.
                                </template>
                            </multiselect>
                        </div>

                    </div>

                    <div v-if="item.id_plano && procedimentos">

                        <div class="form-row mb-2">
                            <div class="col col-12 col-md-4">
                                <az-input icon="fas fa-filter" 
                                    type="select" 
                                    optionsMode="esp-ativas"
                                    optionsName="esp-ativas"
                                    placeholder="Todas"
                                    v-model="especialidade" />
                            </div>
                            <div class="col col-12 col-md-5">
                                <az-input icon="fas fa-search" v-model="search_item" @input="refreshValores()">
                                    <template v-slot:buttonposb>
                                        <importacao 
                                            v-if="!proc_por_tabela" 
                                            service="unidade_procedimento_planos" 
                                            @refresh="reload()"
                                            :parms="{ 
                                                id_plano: item.id_plano
                                            }" />
                                    </template>
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-3 d-flex flex-column">
                                <div class="btn-group mb-1" role="group" aria-label="Basic example">
                                    <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                                    @click="viewMode = 'A'">
                                        Ativos
                                    </button>
                                    <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                                    @click="viewMode = 'T'">
                                        Todos
                                    </button>
                                </div>
                            </div>

                        </div>

                        <!-- Ajuste de itens da tabela -->
                        <div class="card mt-3 w3-animate-opacity" v-if="edicao_valor && viewMode == 'A'">
                            <div class="card-header d-flex justify-content-between">
                                <span>Editar Valor</span>
                                <a href="#" @click.prevent="edicao_valor = null" class="card-link text-dark">
                                    <i class="fa fa-times" aria-hidden="true"></i>
                                </a>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col col-12 col-md-1 d-flex flex-column">

                                        <button class="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown">
                                            <i class="fas fa-plus fa-fw" v-if="ajuste_item == 'plus'"></i>
                                            <i class="fa fa-minus fa-fw" v-else-if="ajuste_item == 'minus'"></i>
                                            <i class="fas fa-edit fa-fw" v-else-if="ajuste_item == 'edit'"></i>
                                            <i class="fas fa-equals fa-fw" v-else-if="ajuste_item == 'tabela'"></i>
                                            <i class="fas fa-equals fa-fw" v-else-if="ajuste_item == 'equals'"></i>
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <a class="dropdown-item" href="#" @click.prevent="ajuste_item = 'plus'">
                                                <i class="fas fa-plus fa-fw mr-2"></i>Aumentar
                                            </a>
                                            <a class="dropdown-item" href="#" @click.prevent="ajuste_item = 'minus'">
                                                <i class="fa fa-minus fa-fw mr-2" aria-hidden="true"></i>Reduzir
                                            </a>
                                            <a class="dropdown-item" href="#" @click.prevent="ajuste_item = 'equals'">
                                                <i class="fas fa-equals fa-fw mr-2" aria-hidden="true"></i>Replicar
                                            </a>
                                        </div>

                                    </div>
                                        
                                    <div class="col col-12 col-md-3">
                                        <az-input
                                            :icon="ajuste_item == 'equals' ? 'fas fa-dollar-sign' : 'fa fa-percent'"
                                            type="money"
                                            :edicao="ajuste_item != 'edit'"
                                            v-model="percentual_ajuste">
                                        </az-input>
                                    </div>

                                    <div class="col col-12 col-md-2 d-flex flex-column">
                                        <az-submit color="success" @click="efetivar_ajuste()">
                                            Atualizar
                                        </az-submit>
                                    </div>

                                    <div class="col col-12 col-md-2 text-right" v-if="1 == 0 && items.data.length > 1">
                                        <div>
                                            <span class="text-muted mr-1">Itens:</span>
                                            <span>{{ items.total }}</span>
                                        </div>
                                        <div>
                                            <span class="text-muted mr-1">Selecionados:</span>
                                            <span>{{ ajustar_todos && ajuste_item != 'edit' ? items.total : items.data.filter(item => item.aplicar).length }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Valores dos Procedimentos -->

                        <template v-if="lista_procedimentos && lista_procedimentos.length">

                            <ul class="list-group">
                                <li class="list-group-item d-flex justify-content-between">
                                    <div>
                                        <input class="mr-3" type="checkbox" id="defaultCheck1" v-if="viewMode == 'T'"
                                            v-model="comporMarcarTodos" @click="marcarTodos ()">
                                        <label class="form-check-label" for="defaultCheck1">
                                            Procedimentos Particulares
                                        </label>
                                        <span class="badge badge-secondary ml-2" title="Quantidade de Procedimentos">
                                            {{ lista_procedimentos.length }}
                                        </span>
                                    </div>
                                    <div class="text-right"> 
                                        <span v-if="setup">
                                            Valor
                                        </span>
                                        <span v-else-if="proc_por_tabela">
                                            &nbsp;
                                        </span>
                                        <template v-else>
                                            <a href="#" class="card-link" @click.prevent="edicao_valor = !edicao_valor" v-if="viewMode == 'A'">
                                                Valor
                                                <i class="fas fa-pen ml-2"></i>
                                            </a>
                                            <input class="ml-3" type="checkbox" v-if="viewMode == 'A' && edicao_valor" v-model="todos_marcados">
                                        </template>
                                    </div>
                                </li>
                                <li class="list-group-item py-2" 
                                    v-for="(proc, ip) in lista_procedimentos" :key="ip">
                                    <div class="d-flex justify-content-between">
                                        <div class="d-flex align-items-center"> 
                                            <input class="mr-3" type="checkbox" 
                                                v-if="proc.unidade_procedimento_planos && viewMode == 'T'"
                                                v-model="proc.unidade_procedimento_planos.fl_ativo" 
                                                id="defaultCheck1"
                                                @click="comporMarcarTodos = false">
                                            <label class="form-check-label" for="defaultCheck1">
                                                <span v-if="setup">
                                                    {{ proc.procedimento.search }}
                                                </span>
                                                <a href="#" class="card-link" @click.prevent="abrirProcedimento (proc)" v-else>
                                                    {{ proc.procedimento.search }}
                                                </a>
                                            </label>
                                        </div>
                                        <div class="d-flex">
                                            <div class="spinner-border spinner-border-sm mr-3" role="status" v-if="atualizando_valores">
                                                <span class="sr-only">Loading...</span>
                                            </div>
                                            <template v-else-if="viewMode == 'A' && edicao_valor">
                                                <template v-if="proc.unidade_procedimento_planos && proc.unidade_procedimento_planos.fl_ativo">
                                                    <span :class="proc.unidade_procedimento_planos.ajustar ? '' : 'text-muted'">
                                                        {{  $util.formatMoeda(proc.unidade_procedimento_planos.dc_valor) }}
                                                        <template v-if="proc.unidade_procedimento_planos.ajustar">
                                                            <i class="fas fa-caret-right mx-2"></i>
                                                            {{  $util.formatMoeda(calc_valor_ajuste(proc.unidade_procedimento_planos)) }}
                                                        </template>
                                                    </span>
                                                    <input class="ml-3" type="checkbox" v-if="viewMode == 'A' && edicao_valor"
                                                        v-model="proc.unidade_procedimento_planos.ajustar">
                                                </template>
                                            </template>
                                            <template v-else>
                                                <div v-if="!proc_por_tabela">
                                                    <!-- Botão para exibir valor de anestesista -->
                                                    <a href="#" class="btn btn-outline-primary mr-2" @click.prevent="proc.unidade_procedimento_planos.tem_anest = !proc.unidade_procedimento_planos.tem_anest"
                                                        v-if="!setup && proc.procedimento.id_classe_procedimento == 2 && proc.unidade_procedimento_planos">
                                                        Anest
                                                    </a>

                                                    <!-- Botão para lançamento de preços específicos para os componentes -->
                                                    <a href="#" class="btn btn-outline-primary mr-2" @click.prevent="editar_preco_consumo(proc)"
                                                        v-if="!setup && proc.procedimento.consumo_procedimentos_count">
                                                        <i class="fa fa-shopping-cart" aria-hidden="true"></i>
                                                    </a>

                                                    <!-- Botão para lançamento de preços específicos para os médicos -->
                                                    <a href="#" class="btn btn-outline-primary mr-2" @click.prevent="incluir_preco_profissional(proc)">
                                                        <i class="fas fa-user-plus"></i>
                                                    </a>
                                                </div>

                                                <div v-if="viewMode != 'T' && exibir_valores && proc.unidade_procedimento_planos && proc.unidade_procedimento_planos.fl_ativo">
                                                    <az-input :mb="false" 
                                                        type="money"
                                                        v-model="proc.unidade_procedimento_planos.dc_valor_filme"
                                                        icon="fas fa-x-ray" 
                                                        class="mr-2"
                                                        v-if="tem_valor_filme && false"
                                                    />
                                                    <az-input 
                                                        v-if="!proc_por_tabela"
                                                        :mb="false" 
                                                        type="money"
                                                        icon="fas fa-dollar-sign"
                                                        v-model="proc.unidade_procedimento_planos.dc_valor" 
                                                    />

                                                    <az-input 
                                                        v-if="!proc_por_tabela && proc.unidade_procedimento_planos && proc.unidade_procedimento_planos.tem_anest"
                                                        :mb="false" 
                                                        type="money"
                                                        v-model="proc.unidade_procedimento_planos.dc_valor_anest" >
                                                        <template v-slot:button-pre>
                                                            <div class="input-group-prepend">
                                                                <span class="input-group-text">
                                                                    Anest
                                                                </span>
                                                            </div>
                                                        </template>
                                                    </az-input>
                                                </div>
                                                <div v-if="!setup">
                                                    <az-audit-log-button 
                                                        class="ml-2"
                                                        model="unidadeProcedimentoPlano" 
                                                        :id="proc.unidade_procedimento_planos.id_unidade_procedimento_plano"
                                                        v-if="proc.unidade_procedimento_planos && proc.unidade_procedimento_planos.id_unidade_procedimento_plano" />
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                    <div v-for="(preco_medico, ipmx) in proc.unidade_procedimento_planos.medicos" :key="ipmx">
                                        <div class="d-flex justify-content-between">
                                            <div class="small">
                                                <a href="#" @click.prevent="editar_preco_profissional(proc, preco_medico)">
                                                    <i class="fa fa-caret-right ml-3" aria-hidden="true"></i>
                                                    <span class="ml-2">{{ preco_medico.medico.search }}</span>
                                                    <span class="badge badge-warning ml-2" v-if="preco_medico.ch_tipo_consulta == 'I' || preco_medico.ch_tipo_consulta == 'S'">
                                                        {{ preco_medico.ch_tipo_consulta == 'I' ? 'Inicial' : 'Subsequente'}}
                                                    </span>
                                                    <span class="badge badge-dark ml-2" v-if="preco_medico.ch_tele_atend">
                                                        {{ preco_medico.ch_tele_atend == 'T' ? 'Teleatendimento' : 'Presencial'}}
                                                    </span>
                                                    <i class="fas fa-equals mx-2" aria-hidden="true"></i>
                                                    {{ $util.formatMoeda(preco_medico.dc_valor) }}
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <pre v-if="1 == 0">{{ proc.unidade_procedimento_planos }}</pre>
                                </li>
                            </ul>

                            <br><br><br><br><br>

                        </template>

                        <az-empty-state msg="Nenhum procedimento localizado." icon="fas fa-search" v-else />

                    </div>

                </div>

            </div>

            <tabelas-e-valores v-else ref="formulario" :id_operadora="item.id_operadora" :id_plano="item.id_plano" />

            <!-- Botões de Atualização -->

            <nav class="navbar fixed-bottom navbar-light bg-light pb-3">
                <div>
                    <az-submit @click="atualizar ()" class="mr-2" v-if="submenu != 'Mat/Med/Taxas' && ( !edicao_valor || viewMode == 'T' )">{{ !item.id_plano ? 'Incluir' : 'Atualizar' }}</az-submit>
                    <button class="btn btn-secondary mr-2" @click="fechar ()">Fechar</button>
                    <button class="btn btn-outline-secondary mr-2" @click="$util.logAudit('plano', item.id_plano)"
                        v-if="item.id_plano && !setup">
                        Log
                    </button>
                </div>
                <div v-if="!setup" class="d-flex">
                    <div v-if="!proc_por_tabela">
                        <print-export :dados="lista_valores" :up="true" />
                    </div>
                    <button class="btn btn-primary ml-1" type="button" v-if="viewMode == 'T' && !edicao_valor && submenu == 'Procedimentos'" @click="atualizarDe()">
                        Habilitar de... 
                    </button>
                    <button class="btn btn-primary ml-1" type="button" v-if="!proc_por_tabela && viewMode == 'A' && !edicao_valor && submenu == 'Procedimentos'" @click="atualizarDe()">
                        Atualizar de... 
                    </button>
                    <button class="btn btn-primary ml-1" type="button" v-if="!proc_por_tabela && viewMode == 'A' && !edicao_valor && submenu == 'Procedimentos'" @click="atualizarDeTabela()">
                        Atualizar de Tabela... 
                    </button>
                    <div class="btn-group dropup ml-1" style="min-width: 200px;" v-if="item.id_plano">
                        <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            {{ ( proc_por_tabela && submenu == 'Mat/Med/Taxas' ) ? 'Tabelas e Valores' : submenu }}
                        </button>
                        <div class="dropdown-menu">
                            <button class="dropdown-item" @click.prevent=" submenu = 'Procedimentos' ">Procedimentos</button>
                            <button class="dropdown-item" @click.prevent=" submenu = 'Mat/Med/Taxas' ">
                                {{ proc_por_tabela ? 'Tabelas e Valores' : 'Mat/Med/Taxas' }}
                            </button>
                        </div>
                    </div>
                </div>

            </nav>

            <!-- Modal -->
            <div class="modal fade" id="atualizarDePlanoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
                <div class="modal-dialog modal-dialog-scrollable" role="document">
                    <div class="modal-content" v-if="item">
                        <div class="modal-header">
                            <h5 class="modal-title">Selecionar Plano</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                        </div>
                        <div class="modal-body">
                            <div class="list-group">
                                <button type="button" class="list-group-item list-group-item-action" @click="atualizarDeSelecioando(plano)" 
                                    v-for="(plano, idx) in lista_planos.filter(el => el.id_plano != this.item.id_plano)" :key="idx">
                                    {{ plano.search }}
                                </button>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- Incluir Preço por Profissional -->
        <div class="modal fade" id="precoProfissionalModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="novo_preco_profissional">
                    <div class="modal-header">
                        <h5 class="modal-title">Adicionar Preço por Profissional</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p class="alert alert-info">{{ novo_preco_profissional.procedimento.search }}</p>
                        <az-input 
                            v-if="!novo_preco_profissional.id_unidade_procedimento_plano_medico"
                            label="Profissional"
                            type="autocomplete" 
                            optionsMode="aql"
                            service="medicos.index"
                            optionsName="medicos-cadastro-ativos"
                            :optionsParm="{ ativos: true }"
                            required
                            :validate="validate"
                            v-model="novo_preco_profissional.medico" />

                        <az-input 
                            v-else
                            label="Profissional"
                            type="text"
                            :edicao="false" 
                            v-model="novo_preco_profissional.medico.search" />

                        <az-input
                            class="mt-3"
                            label="Tipo de Consulta"
                            placeholder="Selecione..."
                            v-if="novo_preco_profissional.procedimento.id_classe_procedimento == 1"
                            type="select"
                            :optionsList="[
                                { id: 'T', search: 'Todas' },
                                { id: 'I', search: 'Consulta Inicial' },
                                { id: 'S', search: 'Consulta Subsequente' }, 
                            ]" 
                            optionsData="id"
                            required
                            :validate="validate"
                            v-model="novo_preco_profissional.ch_tipo_consulta" />

                        <az-input
                            class="mt-3"
                            label="Presencial/Teleatendimento"
                            placeholder="Qualquer"
                            v-if="novo_preco_profissional.procedimento.id_classe_procedimento == 1"
                            type="select"
                            :optionsList="[
                                { id: 'P', search: 'Presencial' },
                                { id: 'T', search: 'Teleatendimento' },
                            ]" 
                            optionsData="id"
                            :validate="validate"
                            v-model="novo_preco_profissional.ch_tele_atend" />

                        <az-input 
                            class="mt-3"
                            label="Preço para o Profissional"
                            type="money"
                            required
                            :validate="validate"
                            v-model="novo_preco_profissional.dc_valor" />

                        <pre v-if="false">{{ novo_preco_profissional }}</pre>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button 
                            model="unidadeProcedimentoPlanoMedico" 
                            :id="novo_preco_profissional.id_unidade_procedimento_plano_medico"
                            v-if="novo_preco_profissional.id_unidade_procedimento_plano_medico" />
                        <az-submit @click="remover_preco_profissional()" color="danger" v-if="novo_preco_profissional.id_unidade_procedimento_plano_medico">Remover</az-submit>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar_novo_preco_profissional()">{{ novo_preco_profissional.id_unidade_procedimento_plano_medico ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="tabelasModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="tabelas">
                    <div class="modal-header">
                        <h5 class="modal-title">Selecione a Tabela</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!tabelas.length" />
                        <div class="list-group" v-else>
                            <button type="button" class="list-group-item list-group-item-action d-flex justify-content-between" v-for="(tabela, itx) in tabelas" :key="itx" @click="selecionar_tabela_atualizar(tabela)">
                                <span>{{ tabela.search }}</span>
                                <span class="badge badge-secondary">
                                    {{ tabela.item_tabelas_count }}
                                </span>
                            </button>
                        </div>
                        <pre v-if="false">{{ tabelas }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Preço dos Consumos Modal -->
        <div class="modal fade" id="precoConsumoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content" v-if="edicao_preco_consumo">
                    <div class="modal-header">
                        <h5 class="modal-title">Componentes Preços: {{ edicao_preco_consumo.procedimento.search }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!edicao_preco_consumo.consumos" />

                        <template v-else>
                            <p class="alert alert-info">Definição de preços específicos dos componentes quando lançado com esse procedimento.</p>

                            <div class="form-row" v-for="(consumo, icx) in edicao_preco_consumo.consumos.consumo_procedimentos" :key="icx">
                                <div class="col col-12 col-md-6">
                                    <az-input 
                                        type="label"
                                        :label="consumo.search" />
                                </div>
                                <div class="col col-12 col-md-3">
                                    <az-input 
                                        type="checkbox-group"
                                        label="Definir"
                                        v-model="consumo.tem_valor_plano"
                                        @input="selecao_valor_plano(consumo)" />
                                </div>
                                <div class="col col-12 col-md-3" v-if="consumo.tem_valor_plano">
                                    <az-input
                                        v-if="consumo && consumo.valor_plano"
                                        type="money"
                                        required
                                        :validate="validate"
                                        v-model="consumo.valor_plano.dc_valor_unitario" />
                                </div>
                            </div>
                        </template>

                        <pre v-if="false">{{ edicao_preco_consumo }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar_preco_consumo()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzBreakTitle from '../../util/AzBreakTitle.vue';
import TabelasEValores from '../../cadastros/items/Operadora/TabelasEValores.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import PrintExport from '../../shared/PrintExport.vue';
import Multiselect from 'vue-multiselect';
import Importacao from '../../cadastros/shared/Importacao.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            procedimentos: null, 
            validate: false,
            especialidade: "",
            search: "", 
            search_item: "", 
            viewMode: "A",
            comporMarcarTodos: false, 
            submenu: 'Procedimentos',
            exibir_valores: true, 
            viewModePlanos: 'A',
            atualizando_valores: false,

            edicao_valor: null, 
            ajuste_item: "plus",
            percentual_ajuste: 0, 

            novo_preco_profissional: null,
            tabelas: null, 
            tem_valor_filme: false,

            edicao_preco_consumo: null,
            debounce: null, 

            proc_por_tabela: false, 
            plano_com_fornecedor: false, 

            options_classes: [],
        }
    },

    props: ['id_plano', 'setup'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        TabelasEValores,
        AzBreakTitle,
        AzAuditLogButton,
        PrintExport, 
        Multiselect, 
        Importacao
    },

    watch: { 
        especialidade: function () { 
            if ( this.em_edicao ) { 
                this.procedimentos = null; 

                this.$nextTick(() => { 
                    this.editar (this.item);
                });
            }
        },
    },
    
    computed: { 
        lista_valores: function () { 
            return this.lista_procedimentos.map(proc => { 
                return { 
                    id_procedimento: proc.procedimento.id_procedimento, 
                    descricao: proc.procedimento.search,
                    codigo_tuss: proc.procedimento.st_codigo_cbhpm,
                    codigo_sus: proc.procedimento.st_codigo_sus,
                    sigla: proc.procedimento.st_sigla, 
                    valor: proc.unidade_procedimento_planos.dc_valor,
                };
            });
        },

        todos_marcados: { 
            get() { 
                if ( !this.lista_procedimentos )
                    return false;

                return this.lista_procedimentos.findIndex(item => !item.unidade_procedimento_planos.ajustar) < 0;
            },

            set(value) { 
                this.lista_procedimentos.forEach(item => { 
                    item.unidade_procedimento_planos.ajustar = value;
                });
            }
        },
        lista_planos: function () { 
            if ( !this.dados )
                return [];

            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return _.orderBy(
                this.dados.filter(item => this.viewModePlanos == 'T' || item.fl_ativo)
                    .filter(item => ( !this.search || reg.test(JSON.stringify(item))) )
                ,
                'st_plano'
            );
        },
        lista_procedimentos: function () { 
            let pesquisar = this.search_item.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.procedimentos && this.procedimentos.length ? 
                this.procedimentos.filter (item => { 
                    return ( this.viewMode == 'T' || item.unidade_procedimento_planos.fl_ativo ) && 
                        ( !this.especialidade || item.procedimento.id_especialidade == this.especialidade.id_especialidade ) &&
                        ( !this.search_item || reg.test(JSON.stringify(item)) );
                }) : [];
        }
    },

    methods: { 
        habilitarDe() { 
            alert('habilitar de...');
        },

        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },

        atualizar_preco_consumo () { 
            this.$util.atualizar(this, { 
                service: 'valores_particular',
                func: 'save_valor_preco_consumo',
                dados: this.edicao_preco_consumo, 
                modal: 'precoConsumoModal',
                toast: true, 
            });
        },

        selecao_valor_plano (consumo) { 
            if ( consumo && !consumo.valor_plano ) { 
                consumo.valor_plano = { 
                    dc_valor_unitario: 0, 
                };
            }
        },

        editar_preco_consumo (proc) { 
            this.validate = false;

            let edicao = _.cloneDeep(proc);
            edicao.consumos = null;

            this.edicao_preco_consumo = edicao;

            this.$util.load(this, { 
                service: 'procedimentos',
                func: 'show',
                parms: { 
                    id: proc.id_procedimento,
                    id_plano: proc.unidade_procedimento_planos.id_plano, 
                },
                with: [
                    'consumoProcedimentos.consumoProcedimentoOperadoras.operadora',
                    'consumoProcedimentos.consumoProcedimentoOperadoras.plano.operadora',
                    'consumoProcedimentos.valor_plano',
                ],
                loadTo: res => { 
                    this.edicao_preco_consumo.consumos = res;
                    this.edicao_preco_consumo.id_unidade_procedimento_plano = proc.unidade_procedimento_planos.id_unidade_procedimento_plano;
                }
            });

            $('#precoConsumoModal').modal('show');
        },

        selecionar_tabela_atualizar(tabela) { 
            if ( !confirm("Confirma atualizar baseado na tabela " + tabela.search + "?") )
                return;

            $('#tabelasModal').modal('hide');

            this.atualizando_valores = true;

            this.$util.loadItem(this, { 
                service: 'item_tabelas',
                func: 'index',
                with: ['procedimentoItemTabelas'],
                parms: { 
                    id_tabela_versao: tabela.id_tabela_versao,
                    atualizar_particular: true, 
                    vinculados: true, 
                }
            })
            .then(res => { 

                res.forEach(item => { 
                    item.procedimento_item_tabelas.forEach(pit => { 
                        let proc = this.lista_procedimentos.find(el => el.id_procedimento == pit.id_procedimento);

                        if ( proc ) { 
                            if ( proc.unidade_procedimento_planos ) { 
                                proc.unidade_procedimento_planos.dc_valor = item.dc_valor;
                                proc.unidade_procedimento_planos.fl_ativo = true;
                            }
                        }
                    })
                });

            })
            .finally(() => { 
                this.atualizando_valores = false;
            });
        },

        atualizarDeTabela() { 
            this.tabelas = [];
            
            this.$util.load(this, { 
                service: "tabela_versaos",
                parms: { 
                    cadastro_procedimento: true, 
                    contar_procs: true, 
                },
                loadTo: res => { 
                    this.tabelas = res;
                }
            });

            $('#tabelasModal').modal('show');
        },

        remover_preco_profissional() { 
            if ( !confirm('Confirma remoção?') )
                return;
                
            this.$util.atualizar(this, { 
                service: 'tabelas',
                func: 'remover_preco_particular_profissional',
                dados: this.novo_preco_profissional, 
                modal: 'precoProfissionalModal',
                callback: () => { 
                    this.editar ({ id_plano: this.item.id_plano });
                }
            });
        },

        salvar_novo_preco_profissional() { 
            this.$util.atualizar(this, { 
                service: 'tabelas',
                func: 'salvar_preco_particular_profissional',
                dados: this.novo_preco_profissional, 
                modal: 'precoProfissionalModal',
                callback: () => { 
                    this.editar ({ id_plano: this.item.id_plano });
                }
            });
        },

        editar_preco_profissional(proc, preco) { 
            this.validate = false;
            this.novo_preco_profissional = null;

            this.$nextTick(() => { 
                this.novo_preco_profissional = { 
                    id_unidade_procedimento_plano: preco.id_unidade_procedimento_plano, 
                    id_unidade_procedimento_plano_medico: preco.id_unidade_procedimento_plano_medico,
                    procedimento: proc.procedimento, 
                    medico: preco.medico,
                    dc_valor: preco.dc_valor, 
                    ch_tipo_consulta: preco.ch_tipo_consulta, 
                    ch_tele_atend: preco.ch_tele_atend ? preco.ch_tele_atend : "", 
                };

                $('#precoProfissionalModal').modal('show');
            });
        },

        incluir_preco_profissional(item) { 
            this.validate = false;
            this.novo_preco_profissional = null;

            this.$nextTick(() => { 
                this.novo_preco_profissional = { 
                    id_unidade_procedimento_plano: item.unidade_procedimento_planos.id_unidade_procedimento_plano, 
                    procedimento: item.procedimento, 
                    medico: "",
                    dc_valor: 0, 
                    ch_tipo_consulta: 'T', 
                    ch_tele_atend: "", 
                };

                $('#precoProfissionalModal').modal('show');
            });
        },

        efetivar_ajuste() { 

            let lista = this.lista_procedimentos.filter(item => item.unidade_procedimento_planos.ajustar)
                .map(item => {
                    item.unidade_procedimento_planos.dc_valor = this.calc_valor_ajuste(item.unidade_procedimento_planos);
                    return item;
                });

            this.$util.atualizar(this, { 
                service: 'unidade_procedimentos',
                func: 'store_valores_particular',
                dados: lista,
                callback: () => { 
                    this.edicao_valor = false;
                    this.load();
                    this.editar (this.item);
                }
            });

        },

        calc_valor_ajuste(item) { 
            if ( this.ajuste_item == 'equals' ) { 
                return this.percentual_ajuste; 
            }

            return Math.round( 
                100 * item.dc_valor * 
                (
                    ( 
                    ( this.percentual_ajuste / 100 ) * ( this.ajuste_item == 'minus' ? -1 : 1 ) 
                    ) + 1
                )
            ) / 100;
        },

        atualizarDeSelecioando(plano) { 

            this.atualizando_valores = true;

            $('#atualizarDePlanoModal').modal('hide');

            this.$util.loadItem(this, { 
                service: 'unidade_procedimentos',
                func: 'index',
                parms: { 
                    id_plano: plano.id_plano,
                }
            })
            .then(res => { 
               this.lista_procedimentos.forEach(item => { 
                    let outro = res.find(el => el.id_procedimento == item.id_procedimento);

                    if ( outro ) { 
                        if ( outro.unidade_procedimento_planos ) { 
                            if ( this.viewMode == 'T' ) { 
                                item.unidade_procedimento_planos.fl_ativo = true;
                            } else { 
                                item.unidade_procedimento_planos.dc_valor = outro.unidade_procedimento_planos.dc_valor;
                            }
                        }
                    }
               });
            })
            .finally(() => { 
                this.atualizando_valores = false;
            });
            
        },

        atualizarDe() { 
            $('#atualizarDePlanoModal').modal('show');
        },

        refreshValores () { 
            this.exibir_valores = false;

            if (this.debounce) { 
                clearTimeout(this.debounce); 
                this.debounce = null;
            }

            this.$nextTick(() => { 
                this.debounce = setTimeout(() => {
                    this.exibir_valores = true;
                    this.debounce = null;
                }, 400);
            });
        },
        marcarTodos () { 
            this.$nextTick(() => { 
                this.lista_procedimentos.forEach(item => { 
                    item.unidade_procedimento_planos.fl_ativo = !this.comporMarcarTodos;
                });
            });
        },

        abrirProcedimento (proc) { 
            this.$util.abrirProcedimento(proc);

            /*
            this.$router.push({ 
                name: 'c-procedimentos', 
                params: { 
                    id_procedimento: proc.procedimento.id_procedimento,
                }
            });
            */
        },
        incluir_plano () { 
            this.validate = false;

            this.item = {
                id_operadora: 1, 
                id_plano: null, 
                st_plano: "", 
                fl_ativo: true 
            };
            this.em_edicao = true;
        },
        load () { 
            this.$store.commit('loading', true);

            let query = { q: [
                { 
                    name: 'planos.index',
                    id: 'lista',
                    parms: { 
                        cadastro: 'particular', 
                        where: { id_operadora: 1 },
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.lista.status == 200 ) { 
                        this.dados = res.data.lista.data;
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });
        },

        reload() { 
            this.exibir_valores = false;

            this.$nextTick(() => { 
                this.editar(this.item);
            });
        },

        editar (item) { 
            this.$store.commit('loading', true);
            this.validate = false;

            if ( !this.em_edicao ) { 
                this.item = null, 
                this.procedimentos = null;
            }

            this.em_edicao = true;

            let query = { q: [ 
                { 
                    name: 'planos.show',
                    id: 'plano',
                    parms: { 
                        id: item.id_plano,
                        cadastro: true,
                    }
                },
                { 
                    name: 'unidade_procedimentos.index',
                    id: 'procedimentos',
                    parms: { 
                        id_plano: item.id_plano,
                        valores_particular: true, 
                    }
                },
                { 
                    name: 'configuracoes.index',
                    id: 'config',
                    parms: { 
                        where: { 
                            st_slug: 'particular-filme',
                        }
                    }
                },
                { 
                    name: 'configuracoes.index',
                    id: 'partab',
                    parms: { 
                        where: { 
                            st_slug: 'particular-tabela',
                        }
                    }
                },
                { 
                    name: 'configuracoes.index',
                    id: 'partfornec',
                    parms: { 
                        where: { 
                            st_slug: 'particular-com-ad-fornecedor',
                        }
                    }
                },
            ]};

            this.axios.post('/aql?a=valores_particulares', query)
                .then(res => { 
                    if ( res.data.plano.status == 200 ) { 
                        this.item = res.data.plano.data;

                        this.em_edicao = true;

                        if ( this.item.st_plano && !this.setup ) { 
                            let bc = _.cloneDeep(this.breadcrumb);
                            bc.push({ name: this.item.st_plano, path: "" });
                            this.$store.commit('setBreadcrumb', bc);
                        }
                    }

                    if ( res.data.config.status == 200 ) { 
                        this.tem_valor_filme = _.get(res.data.config.data, '0.st_valor') == 1 ? true : false;
                    }

                    if ( res.data.partab.status == 200 ) { 
                        this.proc_por_tabela = _.get(res.data.partab.data, '0.st_valor') == 1 ? true : false;
                    }

                    if ( res.data.partfornec.status == 200 ) { 
                        this.plano_com_fornecedor = _.get(res.data.partfornec.data, '0.st_valor') == 1 ? true : false;
                    }

                    if ( res.data.procedimentos.status == 200 ) { 
                        let procs = res.data.procedimentos.data;
                        this.procedimentos = procs.map(item => { 
                            if ( !item.unidade_procedimento_planos ) {
                                item.unidade_procedimento_planos = { 
                                    id_unidade_procedimento_plano: null, 
                                    id_unidade_procedimento: item.id_unidade_procedimento,
                                    id_plano: this.item.id_plano, 
                                    fl_ativo: false,
                                    dc_valor: 0, 
                                    dc_valor_filme: 0
                                };
                            } else { 
                                if ( item.unidade_procedimento_planos.dc_valor == null ) { 
                                    item.unidade_procedimento_planos.dc_valor = 0;
                                    item.unidade_procedimento_planos.dc_valor_filme = 0;
                                }
                            }

                            return item;
                        })
                        .sort((a,b) => { 
                            return a.procedimento.search > b.procedimento.search ? 1 : -1;
                        });
                    }

                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                    this.exibir_valores = true;

                    if ( this.setup ) { 

                        if ( this.lista_procedimentos && !this.lista_procedimentos.length ) { 
                            this.viewMode = 'T';
                        } else { 
                            this.viewMode = 'A';
                        }

                    }
                });
            
        },
        atualizar () { 

            this.validate = true;

            this.$nextTick (() => { 

                let invalids = $('.invalid');

                if ( invalids.length && $('.invalid').is(':visible') ) { 
       
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Verificar preenchimento dos campos.",
                        life: 3000
                    });

                } else { 

                    this.$store.commit('loading', true);

                    this.item.id_fornecedor = _.get(this.item, 'fornecedor.id_fornecedor');

                    let query = { q: [ 
                        { 
                            name: 'planos.store',
                            id: 'atualizar',
                            parms: { 
                                ...this.item,
                            }
                        }
                    ]};
                    
                    if ( this.item.id_plano ) { 
                        
                        query.q.push({ 
                            name: 'unidade_procedimentos.store_valores_particular',
                            id: 'valores',
                            parms: { 
                                ...this.procedimentos,
                            }
                        });

                    }

                    this.axios.post('/aql', query)
                        .then (res => { 
                            if ( res.data.atualizar.status == 200 ) { 
                                this.load();

                                if ( !this.item.id_plano ) { 

                                    this.editar (res.data.atualizar.data);

                                } else { 

                                    if ( res.data.valores.status == 200 )
                                        this.procedimentos = res.data.valores.data;

                                }

                                this.$toast.add({
                                        severity: "success",
                                        summary: "Atenção",
                                        detail: "Cadastro atualizado.",
                                        life: 3000
                                    });
                            }
                        })
                        .finally(() => { 
                            this.$store.commit('loading', false);

                            if ( this.lista_procedimentos && this.lista_procedimentos.length && this.viewMode == 'T' && this.setup ) { 
                                this.viewMode = 'A';
                            }
                        });

                }

            });

        },
        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;

            if ( !this.setup ) { 
                this.$store.commit('setBreadcrumb', this.breadcrumb);
            }
        },
        toggle_plano (item) { 

            this.$store.commit('loading', true);

            let query = { q: [ 
                { 
                    name: 'planos.toggle',
                    id: 'toggle',
                    parms: { 
                        ...item,
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.toggle.status == 200 ) { 
                        //
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });

        }
    },

    mounted () { 
        this.load ();

        if ( !this.setup ) { 
            this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Valores Particular", path: '/config/valores-particulares' },
            ];

            this.$store.commit('setBreadcrumb', this.breadcrumb);

            this.$util.loadItem(this, { 
                service: 'planos',
                func: 'tags',
            })
            .then(res => { 
                this.options_classes = res;
            });
        }

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>